module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_SimoneGenatt-f9d9a9f7e53f6ab1afc1b94146127fcf.png";